interface ParsedConnectionString {
	port?: string;
	database?: string;
}

class ConnectionStringParser implements ParsedConnectionString {
	private connectionString: string;

	private constructor(connectionString: string) {
		this.connectionString = connectionString || '';
	}

	private parse(): ParsedConnectionString {
		const ret: ParsedConnectionString = {};
		if (!this.connectionString) {
			return ret;
		}
		return this.connectionString
			.split(';')
			.filter(el => el.length > 0)
			.reduce((acc, cur: string) => {
				const [key, value] = cur.split('=');
				if (!key || !value) {
					return acc;
				}
				return {
					...acc,
					[key.trim().toLowerCase()]: value.trim(),
				};
			}, ret);
	}

	get database(): string {
		return this.parse().database || '';
	}

	get port(): string {
		return this.parse().port || '';
	}

	public static from(connectionString: string): ConnectionStringParser {
		return new ConnectionStringParser(connectionString);
	}
}

export default ConnectionStringParser;
